import type { DataProvider } from "@refinedev/core";
import { apiClient } from "../../api/apiClient";

export const dataProvider: DataProvider = {
  getList: async ({ resource, pagination }) => {
    const pageNumber = pagination?.current ?? 1;
    const pageSize = pagination?.pageSize ?? 20;
    const { data } = await apiClient.post(`/${resource}/paged`, { pageNumber, pageSize });
    const result = data?.data ?? data;
    const rows = result?.items ?? result?.data ?? result ?? [];
    return { data: rows, total: result?.totalCount ?? result?.total ?? rows.length };
  },
  getOne: async ({ resource, id }) => {
    const { data } = await apiClient.get(`/${resource}/${id}`);
    return { data: data?.data ?? data };
  },
  create: async ({ resource, variables }) => {
    const { data } = await apiClient.post(`/${resource}`, variables);
    return { data: data?.data ?? data };
  },
  update: async ({ resource, id, variables }) => {
    const { data } = await apiClient.put(`/${resource}/${id}`, variables);
    return { data: data?.data ?? data };
  },
  deleteOne: async ({ resource, id }) => {
    const { data } = await apiClient.delete(`/${resource}/${id}`);
    return { data: data?.data ?? data };
  },
  getApiUrl: () => "/api",
  custom: async ({ url, method, payload, query }) => {
    const { data } = await apiClient.request({ url, method, data: payload, params: query });
    return { data: data?.data ?? data };
  }
};
